var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshedBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "50px",
    viewBox: "0 0 30 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Badge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JOOR-Events---JAN-2021-Update",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hover-State-Colors",
    transform: "translate(-948.000000, -420.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Refreshed",
    transform: "translate(923.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-6",
    transform: "translate(25.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Badge",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 L30,0 L30,0 L30,35 C30,43.2842712 23.2842712,50 15,50 C6.71572875,50 1.01453063e-15,43.2842712 0,35 L0,15 C-1.01453063e-15,6.71572875 6.71572875,1.52179594e-15 15,0 Z",
    id: "Rectangle",
    fill: "#5C7284"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 4,
    y: 4,
    width: 22,
    height: 42,
    rx: 11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#B620E0",
    strokeWidth: 2,
    x: 10,
    y: 9,
    width: 10,
    height: 32,
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Evergreen",
    transform: "translate(15.000000, 13.000000)",
    fill: "#B620E0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.414214, 0.585786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4501451,0.586079023 L4.62446266,0.596813116 C5.25723053,0.57090182 5.68019017,0.754262276 6.03835858,1.04952182 L6.03835858,1.04952182 L9,4 C9.39052429,4.39052429 9.58578644,4.90236893 9.58578644,5.41421356 C9.58578644,5.9260582 9.39052429,6.43790283 9,6.82842712 C8.64157665,7.18685047 8.18094104,7.38068615 7.71196404,7.41024173 C7.21451913,7.44159139 6.7079277,7.28730876 6.30341141,6.94907158 L6.30341141,6.94907158 L4.58741824,5.24125765 L3,6.82842712 C2.60947571,7.21895142 2.09763107,7.41421356 1.58578644,7.41421356 C1.0739418,7.41421356 0.562097167,7.21895142 0.171572875,6.82842712 C-0.218951416,6.43790283 -0.414213562,5.9260582 -0.414213562,5.41421356 C-0.414213562,4.90236893 -0.218951416,4.39052429 0.171572875,4 L0.171572875,4 L3,1.17157288 C3.44403327,0.727539606 4.04495032,0.535749464 4.62446266,0.596813116 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    transform: "translate(4.585786, 4.000000) rotate(180.000000) translate(-4.585786, -4.000000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.58578644,
    y: 0.414213562,
    width: 2,
    height: 5
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshedBadge);
export default __webpack_public_path__ + "static/media/refreshed-badge.58624e44.svg";
export { ForwardRef as ReactComponent };